import mixpanel from 'mixpanel-browser';
import { useSelector } from 'react-redux';
import { MODE } from '../../constants/config';
import { RootState } from '../../store/store';

type ReturnType = {
  trackEvent: (name: string) => void;
};

export const useMixPanel = (): ReturnType => {
  const { isMixPanelInitialized } = useSelector(
    (state: RootState) => state.auth
  );

  const isCurrentModeDev = MODE === 'local';

  const trackEvent = (eventName: string) => {
    const checkedEventName = eventName.length
      ? `admin-dashboard/${eventName}`
      : '';

    if (isMixPanelInitialized && isCurrentModeDev) {
      try {
        mixpanel?.track(checkedEventName);

        // eslint-disable-next-line
      } catch (error) {
        // catch crash if mixpanel is not initialized
      }
    }
  };

  return {
    trackEvent,
  };
};
